import { lazy } from "react";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import { HabitationalBasicDetails } from "./HabitationalBasicDetails/HabitationalBasicDetails";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { RiskLocationRoot } from "./RiskLocationRoot";
import { HabitationalCreateTask } from "./HabitationalBasicDetails/HabitationalTask/HabitationalTask";
import { HabitationalAttachmentList } from "./HabitationalBasicDetails/Attachment/AttachmentList";
import { HabitationalNoteFormList } from "./HabitationalNoteForm/HabitationalNoteFormList";
import { HabitationalApplicationList } from "./HabitationalApplicationForm/HabitationalApplicationList";
import { HabitationalCSIOEDocsList } from "./HabitationalCSIOEDocs/HabitatioanlCsioEDocsList";
import { HabitationalCSIOEDocsWrapper } from "./HabitationalCSIOEDocs/HabitationalCSIOEDocsWrapper";
import { HabitationalCSIOEDIList } from "./HabitationalCSIOEDIList/HabitationalCSIOEDIList";
import { HabitationalCSIOApplicationTab } from "./HabitationalCsioApplicationTab";
import { HabitationalPolicyChangeList } from "./HabitationalPolicyChangeRequest/HabitationalPolicyChangeList";
import { HabitationalPolicyChangeReqForm } from "./HabitationalPolicyChangeRequest/HabitationalPolicyChangeRequest";
import { HabitationalPolicyChangeReqFormV2 } from "./HabitationalPolicyChangeRequest/v2/HabitationalPolicyChangeReqFormV2";
import { HabitationalCancellation } from "./HabitationalCancellation/HabitationalCancellation";
import { HabitationalConsentForm } from "./HabitationalConsentForm/HabitationalConsentForm";
import { HabitationalDwellingDeclaration } from "./HabitationalDwellingDeclaration/HabitationalDwellingDeclaration";
import { HabitationalDwelling } from "./HabitationalDwelling/HabitationalDwelling";
import { HabitationalSequences } from "./Sequences/HabitationalSequences";

const HabitationalQuoteList = Loadable(
  lazy(() =>
    import(
      "./HabitationalQuote/HabitationalQuoteList"
    ).then(({ HabitationalQuoteList }) => ({
      default: HabitationalQuoteList,
    }))
  )
);
const HabitationalQuote = Loadable(
  lazy(() =>
    import(
      "./HabitationalQuote/HabitationalQuote"
    ).then(({ HabitationalQuote }) => ({
      default: HabitationalQuote,
    }))
  )
);
const HabitationalClaim = Loadable(
  lazy(() =>
    import(
      "./HabitationalClaim/Claim"
    ).then(({ HabitationalClaim }) => ({
      default: HabitationalClaim,
    }))
  )
);
const HabitationalAllTasks = Loadable(
  lazy(() =>
    import(
      "./HabitationalPolicyNotes/HabitationalActivitiesTabs"
    ).then(({ HabitationalActivitiesTabs }) => ({
      default: HabitationalActivitiesTabs,
    }))
  )
);
const HabitationalClaimTabs = Loadable(
  lazy(() =>
    import(
      "./HabitationalClaim/HabitationalClaimTabs"
    ).then(({ HabitationalClaimTabs }) => ({
      default: HabitationalClaimTabs,
    }))
  )
);
const HabitationalInterestedPartiesPage = Loadable(
  lazy(() =>
    import(
      "./InterestedParties/InterestedPartiesPage"
    ).then(({ InterestedPartiesPage }) => ({
      default: InterestedPartiesPage,
    }))
  )
);
const HabitationalRiskLocationPage = Loadable(
  lazy(() =>
    import(
      "./HabitationalRiskLocation/HabitationalRiskLocationPage"
    ).then(({ HabitationalRiskLocationPage }) => ({
      default: HabitationalRiskLocationPage,
    }))
  )
);
const HabitationalCoverageRoot = Loadable(
  lazy(() =>
    import(
      "./CoverageRoot"
    ).then(({ CoverageRoot }) => ({
      default: CoverageRoot,
    }))
  )
);
const HabitationalCoveragePage = Loadable(
  lazy(() =>
    import(
      "./HabitationalCoverages/HabitationalCoveragePage"
    ).then(({ HabitationalCoveragePage }) => ({
      default: HabitationalCoveragePage,
    }))
  )
);
const HabitationalScheduledSummary = Loadable(
  lazy(() =>
    import(
      "./HabitationalScheduledSummary/HabitationalScheduledSummary"
    ).then(({ HabitationalScheduleSummary }) => ({
      default: HabitationalScheduleSummary,
    }))
  )
);
const HabitationalScheduleDetailPage = Loadable(
  lazy(() =>
    import(
      "./HabitationalScheduleDetail/HabitationalScheduleDetailPage"
    ).then(({ HabitationalScheduleDetailPage }) => ({
      default: HabitationalScheduleDetailPage,
    }))
  )
);
const HabitationalHistory = Loadable(
  lazy(() =>
    import(
      "./HabitationalBasicDetails/HabitationalHistory/HabitationalHistory"
    ).then(({ HabitationalHistory }) => ({
      default: HabitationalHistory,
    }))
  )
);
const HabitationalPolicyNoteForm = Loadable(
  lazy(() =>
    import(
      "./HabitationalNoteForm/HabitationalNoteForm"
    ).then(({ HabitationalNoteForm }) => ({
      default: HabitationalNoteForm,
    }))
  )
);
const HabitationalTaskActivity = Loadable(
  lazy(() =>
    import(
      "./TaskActivity/TaskActivity"
    ).then(({ HabitationalTaskActivity }) => ({
      default: HabitationalTaskActivity,
    }))
  )
);
const HabitationalApplicationTabs = Loadable(
  lazy(() =>
    import(
      "./HabitationalApplicationForm/HabitationalApplicationStepTabs"
    ).then(({ HabitationalApplicationStepTab }) => ({
      default: HabitationalApplicationStepTab,
    }))
  )
);
const HabitationalCSIOApplicationTabs = Loadable(
  lazy(() =>
    import(
      "./HabitationalCsioApplicationForm/HabitationalCsioApplicationStepTabs"
    ).then(({ HabitationalCsioApplicationUI }) => ({
      default: HabitationalCsioApplicationUI,
    }))
  )
);
const HabitationalBinderCsio = Loadable(
  lazy(() =>
    import(
      "./HabitationalBinderCSIO/HabitationalBinderCSIO"
    ).then(({ HabitationalBinderCSIO }) => ({
      default: HabitationalBinderCSIO,
    }))
  )
);
const HabitationalBinderNonCsio = Loadable(
  lazy(() =>
    import(
      "./HabitationalBinderNonCSIO/HabitationalBinderNonCSIO"
    ).then(({ HabitationalBinderNonCSIO }) => ({
      default: HabitationalBinderNonCSIO,
    }))
  )
);
const HabitationalPolicyForms = Loadable(
  lazy(() =>
    import(
      "./HabitationalPolicyForms"
    ).then(({ HabitationalPolicyForms }) => ({
      default: HabitationalPolicyForms,
    }))
  )
);
const HabitationalPaymentAUthortization = Loadable(
  lazy(() =>
    import(
      "./HabitationalPaymentAuthorization/HabitationalPaymentAuthorization"
    ).then(({ HabitationalPaymentAuthorization }) => ({
      default: HabitationalPaymentAuthorization,
    }))
  )
);
const HabitationalPrePaymentAuthorization = Loadable(
  lazy(() =>
    import(
      "./HabitationalPrePaymentAuthorization/HabitationalPrePaymentAuthorization"
    ).then(({ HabitationalPrePaymentAuthorization }) => ({
      default: HabitationalPrePaymentAuthorization,
    }))
  )
);

const HabitationalInvoiceList = Loadable(
  lazy(() =>
    import(
      "./HabitationalInvoices/HabitationalInvoiceTabs"
    ).then(({ HabitationalInvoiceTabs }) => ({
      default: HabitationalInvoiceTabs,
    }))
  )
);
const HabitationalInvoiceHistoryWrapper = Loadable(
  lazy(() =>
    import(
      "./HabitationalInvoices/HabitationalInvoiceHistoryWrapper"
    ).then(({ HabitationalInvoiceHistoryWrapper }) => ({
      default: HabitationalInvoiceHistoryWrapper,
    }))
  )
);
const HabitationalInvoice = Loadable(
  lazy(() =>
    import(
      "./HabitationalInvoices/HabitationalInvoice"
    ).then(({ HabitationalInvoice }) => ({
      default: HabitationalInvoice,
    }))
  )
);
const HabitationalBulkInvoiceWrapper = Loadable(
  lazy(() =>
    import(
      "./HabitationalInvoices/HabitationalBulkInvoiceWrapper"
    ).then(({ HabitationalBulkInvoiceWrapper }) => ({
      default: HabitationalBulkInvoiceWrapper,
    }))
  )
);
const HabitationaInvoicePaymentList = Loadable(
  lazy(() =>
    import(
      "./HabitationalInvoices/HabitationalInvoicePaymentList"
    ).then(({ HabitationaInvoicePaymentList }) => ({
      default: HabitationaInvoicePaymentList,
    }))
  )
);
const HabitationalInvoicePaymentWrapper = Loadable(
  lazy(() =>
    import(
      "./HabitationalInvoices/HabitationalInvoicePaymentWrapper"
    ).then(({ HabitationalInvoicePaymentWrapper }) => ({
      default: HabitationalInvoicePaymentWrapper,
    }))
  )
);

const HabitationalQuoteARSWrapper = Loadable(
  lazy(() =>
    import(
      "./HabitationalApplicationForm/HabitationalQuoteARSWrapper"
    ).then(({ HabitationalQuoteARSWrapper }) => ({
      default: HabitationalQuoteARSWrapper,
    }))
  )
);

const HabitationalPolicyContacts = Loadable(
  lazy(() =>
    import("./HabitationalPolicyContacts/HabitationalPolicyContacts").then(
      ({ HabitationalPolicyContacts }) => ({
        default: HabitationalPolicyContacts,
      })
    )
  )
);

export const HabitationalPolicyRoutes =  [
          {
            path: "/habitational-policy/:customerId/basic-details/",
            exact: true,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.HABITATIONAL,
                  MODULE_IDS.HABITATIONAL_POLICY_ADMIN_MANAGER,
                ]}
              >
                <HabitationalBasicDetails />
              </AuthorizedRoute>
            ),
          },
             {
            path: "/habitational-policy/:customerId/basic-details/:customerPolicyId",
            exact:true,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.HABITATIONAL,
                  MODULE_IDS.HABITATIONAL_POLICY_ADMIN_MANAGER,
                ]}
              >
                <HabitationalBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/quote/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalQuoteList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/quote/:customerPolicyId/manage-quote",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalQuote />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/quote/:customerPolicyId/manage-quote/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalQuote />
              </AuthorizedRoute>
            ),
          },
       
          {
            path: "/habitational-policy/:customerId/claims-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalClaim />
              </AuthorizedRoute>
            ),
          },
          
          {
            path: "/habitational-policy/:customerId/all-tasks/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalAllTasks />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/sequences/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalSequences />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/claims-tab/:customerPolicyId",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalClaim />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/claims-tab/:customerPolicyId/claims",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalClaimTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/claims-tab/:customerPolicyId/claims/:claimNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalClaimTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/risk-location-tab/:customerPolicyId",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <RiskLocationRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/risk-location-tab/:customerPolicyId/interested-party",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <HabitationalInterestedPartiesPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/risk-location-tab/:customerPolicyId/interested-party/:interestedNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <HabitationalInterestedPartiesPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/risk-location/:customerPolicyId/application",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalRiskLocationPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/risk-location/:customerPolicyId/application/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalRiskLocationPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/coverage-tab/:customerPolicyId",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCoverageRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-coverages/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCoveragePage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-coverages/:customerPolicyId/:interestedNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCoveragePage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-schedule/:customerPolicyId/summary",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalScheduledSummary />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-schedule/:customerPolicyId/summary/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalScheduledSummary />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-schedule/:customerPolicyId/detail",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalScheduleDetailPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-schedule/:customerPolicyId/detail/:incrementalNumber",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalScheduleDetailPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/activity-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCreateTask />
              </AuthorizedRoute>
            ),
          },
        //   //below this route need to correct
          {
            path: "/habitational-policy/:customerId/activity-tab/:customerPolicyId/task/:taskNumber",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCreateTask />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/history-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalHistory />
              </AuthorizedRoute>
            ),
          },
        //   //below this route need to correct
          {
            path: "/habitational-policy/:customerId/history-tab/:customerPolicyId/history/:taskNumber",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalHistory />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/attachments-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalAttachmentList />
              </AuthorizedRoute>
            ),
          },
        //   //below this route need to correct
          {
            path: "/habitational-policy/:customerId/attachments-tab/:customerPolicyId/history/:taskNumber",
            exact:true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalAttachmentList />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/habitational-policy/:customerId/policy-notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalAllTasks />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalNoteFormList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/notes-tab/:customerPolicyId/note",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/notes-tab/:customerPolicyId/note/:noteNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/task-activity-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalTaskActivity />
              </AuthorizedRoute>
            ),
          },
          
          {
            path: "/habitational-policy/:customerId/application-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalApplicationList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/application-tab/:customerPolicyId/application",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalApplicationTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/csio-edocs-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOEDocsList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOEDocsWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc/:type/:csioEdocsId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOEDocsWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/csio-edi-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOEDIList />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/habitational-policy/:customerId/habitational-application-csio-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOApplicationTab />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-application-csio-tab/:customerPolicyId/application",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOApplicationTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-application-csio-tab/:customerPolicyId/application/:messageGUID",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOApplicationTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-application-csio-tab/:customerPolicyId/edi",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOApplicationTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-application-csio-tab/:customerPolicyId/edi/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOApplicationTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-change-request-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyChangeList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-change-request/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyChangeReqForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-change-request/:customerPolicyId/manage/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyChangeReqForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-change-request-v2/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyChangeReqFormV2 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-change-request-v2/:customerPolicyId/manage/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyChangeReqFormV2 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/habitational-application-csio-tab/:customerPolicyId/policy-change/:messageGUID",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCSIOApplicationTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/application-tab/:customerPolicyId/application/:IncrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalApplicationTabs />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/binder",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBinderCsio />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/binder/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBinderCsio />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/binder/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBinderCsio isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/non-binder",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBinderNonCsio />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/non-binder/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBinderNonCsio />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/non-binder/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBinderNonCsio isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyForms />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/payment",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPaymentAUthortization />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/payment/:authNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPaymentAUthortization />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/payment/duplicate/:authNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPaymentAUthortization isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/pre-payment",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPrePaymentAuthorization />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/pre-payment/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPrePaymentAuthorization />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/pre-payment/duplicate/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPrePaymentAuthorization isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalCancellation />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalConsentForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalConsentForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalConsentForm isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-declaration",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalDwellingDeclaration />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-declaration/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalDwellingDeclaration />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-declaration/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalDwellingDeclaration isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalDwelling />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalDwelling />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling/duplicate/:serialNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalDwelling isDuplicate />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoiceList />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/habitational-policy/:customerId/invoices/:customerPolicyId/payment/history/:invoiceId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoiceHistoryWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/:customerPolicyId/manage",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoice />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/:customerPolicyId/manage/:invoiceId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoice />
              </AuthorizedRoute>
            ),
          },
            {
            path: "/habitational-policy/:customerId/invoices/:customerPolicyId/bulk-invoice",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalBulkInvoiceWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/payments/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationaInvoicePaymentList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/:customerPolicyId/bulk-payment",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoicePaymentWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/payments/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoicePaymentWrapper />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/habitational-policy/:customerId/invoices/payments/:customerPolicyId/manage",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalInvoicePaymentWrapper />
              </AuthorizedRoute>
            ),
          },
              {
                      path: "/habitational-policy/:customerId/application-tab/:customerPolicyId/quote-ars",
                      exact: true,
                      element: (
                        <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                        <HabitationalQuoteARSWrapper/>
                        </AuthorizedRoute>
                      ),
                    },
          {
            path: "/habitational-policy/:customerId/contacts/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                <HabitationalPolicyContacts />
              </AuthorizedRoute>
            ),
          },
        ]